import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';

// Reducers
import documents from './documents/reducer';
import multimidia from './multimidia/reducer';
import domains from './domains/reducer';
import explorer from './explorer/reducer';
import ftp from './ftp/reducer';
import login from './login/reducer';
import newuser from './manageuser/reducer';
import lUsers from './gerenciarUsuarios/reducer';
import mapLayers from './gerenciarMaplayer/reducer';

export default combineReducers({
	documents,
	multimidia,
	domains,
	explorer,
	ftp,
	login,
	newuser,
	router,
	lUsers,
	mapLayers
});


// WEBPACK FOOTER //
// ./src/state/rootReducer.js